import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import ModalDialog from 'shared/modal/dialog';
import {
  TargetDomain,
  TargetDomainMenuActionsType,
} from 'data/targetDomain/targetDomain.types';
import './target-domain-action-menu.scss';

type Props = {
  selectedItem?: TargetDomain;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: ()=> void;
  onDelete: ()=> void;
}

const TargetDomainActionMenu: FunctionComponent<Props> = ({
  selectedItem,
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedItem == null) {
    return null;
  }

  return (
    <div data-testid="XdpMenu" className="xdp-action-menu">
      {hasPrivilegesToCreate && (
      <Button
        className="xdp-action-menu-button"
        data-testid={`${TargetDomainMenuActionsType.Edit}-button`}
        text={t('targetDomain.grid.edit')}
        onClick={onEdit}
      />
      )}
      {hasPrivilegeToDelete && (
      <Button
        className="xdp-action-menu-button"
        data-testid={`${TargetDomainMenuActionsType.Delete}-button`}
        text={t('targetDomain.grid.delete')}
        onClick={handleOpenDeleteDialog}
      />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('targetDomain.deletePopup.title')}
        displayMessage={
          t('targetDomain.deletePopup.message', { name: selectedItem.domain })
        }
        actionText={t('targetDomain.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default TargetDomainActionMenu;
